import { actions } from './slice'

export const { prerequisitesChange, setOpenPrerequisites } = actions
